exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".contributor{width:100vw;height:100vh;background-color:hsla(0,0%,93%,.8);z-index:11;position:fixed}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./client/app/components/home/contributor/contributor.scss
// module id = 614
// module chunks = 0